interface UserWithRoles {
    roles: string[];
    permissions: string[];
}

export function hasRole(user: UserWithRoles | null | undefined, role: string): boolean {
    if (!user?.roles) return false;
    return user.roles.includes(role);
}

export function hasAnyRole(user: UserWithRoles | null | undefined, roles: string[]): boolean {
    if (!user?.roles) return false;
    return roles.some((role) => user.roles.includes(role));
}

export function hasAllRoles(user: UserWithRoles | null | undefined, roles: string[]): boolean {
    if (!user?.roles) return false;
    return roles.every((role) => user.roles.includes(role));
}

export function hasPermission(user: UserWithRoles | null | undefined, permission: string): boolean {
    if (!user?.permissions) return false;
    return user.permissions.includes(permission);
}

export function hasAnyPermission(user: UserWithRoles | null | undefined, permissions: string[]): boolean {
    if (!user?.permissions) return false;
    return permissions.some((p) => user.permissions.includes(p));
}
